import { render } from "./suitcase.vue?vue&type=template&id=0c962e24"
import script from "./suitcase.vue?vue&type=script&lang=js"
export * from "./suitcase.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__